import { render, staticRenderFns } from "./DocAbstract.vue?vue&type=template&id=61cbf320&"
import script from "./DocAbstract.vue?vue&type=script&lang=js&"
export * from "./DocAbstract.vue?vue&type=script&lang=js&"
import style0 from "./DocAbstract.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports